import React, { Component } from "react";
import { Layout } from "antd";
import { Redirect, Route, Switch } from "react-router-dom";
import PageNotFound from "../../common/PageNotFound";
import PrivateRoute from "../../../containers/ConnectedAuthRoute";
import Loadable from "react-loadable";

const { Content } = Layout;

const SponsorListContainer = Loadable({
  loader: () => import("../../../containers/Categories/SponsorListContainer"),
  loading() {
    return <div>Loading...</div>;
  },
});

const CategoryListContainer = Loadable({
  loader: () => import("../../../containers/Categories/CategoryListContainer"),
  loading() {
    return <div>Loading...</div>;
  },
});

const AuthorListContainer = Loadable({
  loader: () => import("../../../containers/Categories/AuthorListContainer"),
  loading() {
    return <div>Loading...</div>;
  },
});

const SpeakerListContainer = Loadable({
  loader: () => import("../../../containers/Categories/SpeakerListContainer"),
  loading() {
    return <div>Loading...</div>;
  },
});

const UserListContainer = Loadable({
  loader: () => import("../../../containers/Users/UserListContainer"),
  loading() {
    return <div>Loading...</div>;
  },
});

const BookListContainer = Loadable({
  loader: () => import("../../../containers/Books/BookListContainer"),
  loading() {
    return <div>Loading...</div>;
  },
});

const ChapterAddContainer = Loadable({
  loader: () => import("../../../containers/Books/ChapterAddContainer"),
  loading() {
    return <div>Loading...</div>;
  },
});

const RegisterListContainer = Loadable({
  loader: () => import("../../../containers/Users/RegisterListContainer"),
  loading() {
    return <div>Loading...</div>;
  },
});
const AdminListContainer = Loadable({
  loader: () => import("../../../containers/Users/AdminListContainer"),
  loading() {
    return <div>Loading...</div>;
  },
});

class ContentTemplate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "",
    };
  }

  render() {
    return (
      <Content style={{ padding: "0 50px" }}>
        <div style={{ margin: "16px 0" }}>
          <h1 style={{ textAlign: "center", fontSize: "30px" }}>
            {this.props.menuTitle}
          </h1>
        </div>
        <div
          style={{
            background: "#fff",
            padding: 24,
            minHeight: "calc(100vh - 55px)",
          }}
        >
          <Switch>
            {/*<PrivateRoute exact path="/" component={Dashboard} redirectTo='/login'/>*/}
            {/*<PrivateRoute path="/accounts" component={AccountListContainer} redirectTo='/login' />*/}
            <Redirect exact from={"/"} to={"/admins"} />
            <PrivateRoute
              path="/users"
              component={UserListContainer}
              authed={true}
            />
            <PrivateRoute
              path="/categories"
              component={CategoryListContainer}
              authed={true}
            />
            <PrivateRoute
              path="/admins"
              component={AdminListContainer}
              authed={true}
            />
            <PrivateRoute
              path="/registers"
              component={RegisterListContainer}
              authed={true}
            />
            <PrivateRoute
              path="/chapters"
              component={ChapterAddContainer}
              authed={true}
            />
            <PrivateRoute
              path="/books"
              component={BookListContainer}
              authed={true}
            />
            <PrivateRoute
              path="/authors"
              component={AuthorListContainer}
              authed={true}
            />
            <PrivateRoute
              path="/speakers"
              component={SpeakerListContainer}
              authed={true}
            />
            <PrivateRoute
              path="/sponsors"
              component={SponsorListContainer}
              authed={true}
            />

            <Route component={PageNotFound} />
          </Switch>
        </div>
      </Content>
    );
  }
}

export default ContentTemplate;